import noop from 'utils/noop';
import { useCampaignContext } from 'modules/campaigns/editor/context';
import { MessageMedium } from 'modules/domains/campaign';
import { EmbeddedMessage } from 'constants/messageMediums';
import { SectionWrapper, SectionHeader } from '../Sections.styled';
import { WebPushBehavior } from './WebPushBehavior';
import { InAppBehavior } from './InAppBehavior';
import { PushBehavior } from './PushBehavior';
import { EmbeddedBehavior } from './EmbeddedBehavior';

export const BEHAVIOR_SECTION_TEST_ID = 'behavior-section';

const BEHAVIOR_MEDIUM_MAPPER = {
  [MessageMedium.InApp]: InAppBehavior,
  [MessageMedium.WebPush]: WebPushBehavior,
  [MessageMedium.Push]: PushBehavior,
  [EmbeddedMessage]: EmbeddedBehavior,
};

export const BehaviorSection = () => {
  const {
    campaign: { messageMedium },
  } = useCampaignContext();

  const MediumBehavior = BEHAVIOR_MEDIUM_MAPPER?.[messageMedium] || noop;

  return (
    <SectionWrapper data-test={BEHAVIOR_SECTION_TEST_ID}>
      <SectionHeader>Behavior</SectionHeader>
      <MediumBehavior />
    </SectionWrapper>
  );
};
